// Minimal RFC 9562 UUIDv7 generator.
// 48-bit unix ms timestamp | 4-bit ver (7) | 12-bit rand_a | 2-bit var | 62-bit rand_b.

export function uuidv7(): string {
  const ms = Date.now()
  const tsHex = ms.toString(16).padStart(12, '0')
  const rand = new Uint8Array(10)
  crypto.getRandomValues(rand)

  rand[0] = (rand[0] & 0x0f) | 0x70
  rand[2] = (rand[2] & 0x3f) | 0x80

  const hex = Array.from(rand, (b) => b.toString(16).padStart(2, '0')).join('')
  return `${tsHex.slice(0, 8)}-${tsHex.slice(8, 12)}-${hex.slice(0, 4)}-${hex.slice(4, 8)}-${hex.slice(8, 20)}`
}
